import React, { useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { selectedDepartmentAtom } from '../shared/selected.department';
import { turnModeAtom } from '../shared/turn.mode';
import { selectedTurnBase } from '../shared/selected.turn.base';
import { selectedTurnItem } from '../shared/selected.turn.items';
import { selectedDoctorAtom } from '../shared/selected.doctor';
import { selectedSpecialityServiceAtom } from '../shared/selected.speciality.service';

const useLockForward = (
  data,
  steps,
  doctors,
  turnBaseData,
  specialityService,
  departments
) => {
  const [isLocked, setLocked] = useState(false);

  const [selectedDepartment] = useAtom(
    selectedDepartmentAtom
  );

  const [selectTurnItem] = useAtom(selectedTurnItem);

  //turn mode works when it is previously defined in departments, useless here for now
  const [turnMode] = useAtom(turnModeAtom);

  //turn base on the other hand works when user should manually choose one of them instead of pre defined in departments
  const [turnBase] = useAtom(selectedTurnBase);

  const [selectedDoctor] = useAtom(selectedDoctorAtom);

  const [selectedTurn] = useAtom(selectedTurnItem);

  const [selectedSpecialityService] = useAtom(
    selectedSpecialityServiceAtom
  );

  // console.log('turnBase->', selectedDepartment);

  useEffect(() => {
    if (
      !data.acceptTerms ||
      (steps === 1 && !selectedDepartment) ||
      (steps === 2 && turnBase === null) ||
      (steps === 3 && selectTurnItem === null) ||
      (steps === 3 && !doctors) ||
      (steps === 5 && !selectedDoctor) ||
      (steps === 2 && !turnBase) ||
      (steps === 2 && !doctors && selectedTurn) ||
      (steps === 1 &&
        !doctors &&
        selectedDepartment?.NobatBaPezeshKYaVahed === 2 &&
        turnBaseData?.serviceBased?.length === 1) ||
      (steps === 3 &&
        turnBase === 'speciality' &&
        doctors?.length === 1 &&
        !specialityService) ||
      !departments
    ) {
      setLocked(true);
    } else {
      setLocked(false);
    }
  }, [data, steps, selectedDepartment]);

  return isLocked;
};

export default useLockForward;
